// extracted by mini-css-extract-plugin
export default {"section":"section---d6nOp","warnMessage":"warnMessage---F5Q2_","warnIcon":"warnIcon---sFX7d"};